import { PAGE_NAMES, USER_PAYMENTS_STATUS_RESOURCES, USER_PROFILE_RESOURCES } from 'constant';
import deposits from 'assets/userProfile/deposits.png';
import withdrawals from 'assets/userProfile/withdrawals.png';

import UserDeposits from './userDeposits';
import UserWithdrawals from './userWithdrawals';

export const URL = {
	[USER_PAYMENTS_STATUS_RESOURCES.userDeposits]: `/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.paymentsStatus}/${USER_PAYMENTS_STATUS_RESOURCES.userDeposits}`,
	[USER_PAYMENTS_STATUS_RESOURCES.userWithdrawals]: `/${PAGE_NAMES.userProfile}/${USER_PROFILE_RESOURCES.paymentsStatus}/${USER_PAYMENTS_STATUS_RESOURCES.userWithdrawals}`
};

export const COMPONENT = {
	[USER_PAYMENTS_STATUS_RESOURCES.userDeposits]: UserDeposits,
	[USER_PAYMENTS_STATUS_RESOURCES.userWithdrawals]: UserWithdrawals
};

export const LABEL = {
	[USER_PAYMENTS_STATUS_RESOURCES.userDeposits]: 'User Deposits',
	[USER_PAYMENTS_STATUS_RESOURCES.userWithdrawals]: 'User Withdrawals'
};

export const IMAGE_SOURCE = {
	[USER_PAYMENTS_STATUS_RESOURCES.userDeposits]: deposits,
	[USER_PAYMENTS_STATUS_RESOURCES.userWithdrawals]: withdrawals
};
